import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Notifications, {notify} from 'react-notify-toast';
import { connectionGet, connectionFilePost } from '../../utils/connection';
import { inject, observer } from 'mobx-react';
import Modal from 'react-bootstrap4-modal';

class DocumentForm extends Component{
    constructor(props){
        super(props);
        this.state = {
        }
    }

    render(){
        if (!this.props.document) return <div className="alert alert-info">Loading Document...</div>;
        const {handleInputChange, document, modalBackgroundClicked, saveDocument, handleFileChange} = this.props;
        return (
        <React.Fragment>
          <header className="quickview-header">
              <p className="quickview-title lead fw-400">{document.id !== 0 ? document.name : "Add New Document"}</p>
              <span className="close" onClick={modalBackgroundClicked}><i className="ti-close"></i></span>
          </header>
          <div className="quickview-body ps-container ps-theme-default">
              <div className="quickview-block">
                <div className="form-group">
                    <label>Name</label>
                    <input className="form-control" name="name" type="text" onChange={handleInputChange} value={document.name}/>
                </div>
                <div className="form-group">
                    <label>Description</label>
                    <textarea className="form-control" name="description" onChange={handleInputChange} value={document.description}></textarea>
                </div>
                {document.id === 0 ?
                <div className="form-group">
                  <label>Select File</label>
                  <input className="form-control" name="name" type="file" accept="application/pdf" onChange={handleFileChange}/>
                </div>
                : <div className="alert alert-info">You cannot update uploaded files</div>}
              </div>
          </div>
          <footer className="quickview-footer flex-row-reverse">
            <button type="button" className="btn btn-secondary" onClick={modalBackgroundClicked}>Close</button>
            <button type="button" className="btn btn-primary" onClick={saveDocument}>Save</button>
          </footer>
        </React.Fragment>
        )
    }
}

@inject('userStore')
class SettingsDocument extends Component {
    constructor(props){
        super(props);
        this.state = {
            business:null,
            document_list:[],
            visible:false,
            selectedItem:null
        }
    }

    componentDidMount(){
      this.setState({
        business:this.props.business
      }, () => {this.fetchDocumentList()});
    }

    modalBackgroundClicked = () => {
      this.setState({
        visible:!this.state.visible, selectedItem:null
      });
    }

    modalHandler = (document) => {
      this.setState({
        selectedItem:document,
        visible:true
      })
    }

    handleInputChange = (e) => {
      let updatedItem = Object.assign({}, this.state.selectedItem);
      // const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
      let value = e.target.value;
      updatedItem[e.target.name] = value;
      this.setState({selectedItem:updatedItem});
    }

    handleFileChange = event => {
      // Update the state
      let updatedItem = Object.assign({}, this.state.selectedItem);
      updatedItem.file = event.target.files[0];
      this.setState({
        selectedItem:updatedItem
      },()=>console.log(this.state.selectedItem));
    }

    fetchDocumentList = () => {
      if (this.state.business){
        connectionGet('business-documents/' + this.state.business.hash_id, {}, {username: this.props.userStore.token}
        ).then((res) => {
          if (res.data.errors === 0){
            this.setState({document_list:res.data.document_list});
          } else {
            notify.show(res.data.message, "error", 4000);
          }
        }).catch((error) => {
          notify.show(error, "error", 4000);
          console.log(error);
          return error;
        });
      }
    }

    saveDocument = () => {
      let formData = new FormData();
      formData.append('file',this.state.selectedItem.file);
      formData.append('id',this.state.selectedItem.id);
      formData.append('name',this.state.selectedItem.name);
      formData.append('description',this.state.selectedItem.description);
      connectionFilePost('business-documents/' + this.state.business.hash_id, formData, {username: this.props.userStore.token}
      ).then((res) => {
        if (res.data.errors === 0){
          this.setState({visible:false, document_list:res.data.document_list}, () => {
            notify.show(res.data.message, "success", 4000);
          });
        } else {
          this.setState({visible:false}, () => {
            notify.show(res.data.message, "error", 4000);
          });
        }
      }).catch((error) => {
        this.setState({visible:false}, () => {
          notify.show(error, "error", 4000);
        });
        console.log(error);
        return error;
      });
    }

    addDocument = () => {
      this.setState({
        selectedItem:{id:0, name:'', description:'', file:null},
        visible:true
      })
    }

    render(){
        if (!this.state.document_list) return <div className="alert alert-info">Loading...</div>;
        return (
        <React.Fragment>
        <Notifications/>
        <div className={this.state.visible ? "quickview quickview-lg reveal" : "quickview quickview-lg"}>
          {this.state.selectedItem ?
            <DocumentForm handleInputChange={this.handleInputChange} document={this.state.selectedItem} modalBackgroundClicked={this.modalBackgroundClicked} saveDocument={this.saveDocument} handleFileChange={this.handleFileChange}/>
          : null}
        </div>
        <div className="card">
            <h4 className="card-title"><strong>Documents</strong><button type="button" onClick={this.addDocument} className="btn btn-sm btn-success pull-right">Add Document</button></h4>
            <div className="card-body">
            {this.state.document_list ?
                <table className="table">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Description</th>
                            <th>Filename</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                    {this.state.document_list.map((bus_document, index)=>
                        <tr key={index}>
                          <td className="v-align-middle">{bus_document.name}</td>
                          <td className="v-align-middle">{bus_document.description}</td>
                          <td className="v-align-middle">{bus_document.document.filename}</td>
                          <td className="v-align-middle">
                            <div className="btn-group btn-group-vertical">
                                <button className="btn btn-sm btn-primary" onClick={()=>this.modalHandler(bus_document)}>Edit</button>
                            </div>
                          </td>
                        </tr>
                    )}
                    </tbody>
                </table>
            : null}
            </div>
        </div>
        </React.Fragment>
        );
    }
}

export default SettingsDocument;



// WEBPACK FOOTER //
// ./src/components/business/SettingsDocument.js